import { Box, TextField, ThemeProvider, Typography, useTheme } from "@mui/material";
import {
  Brecha,
  GeometryBarragem
} from "../../../context";
import { useEffect, useRef, useState } from "react";
import { googleSateliteHybrid, HidroLayer, HidroLayerGroup, HidroMap } from "../../mapa";
import { divIcon, Marker } from "leaflet";
import { GeomBarragem } from "../geomBarragem";
import { BrechaSVG } from "../brechaSVG";
import { generateRandomHash } from "../../../core";

export interface Props {
  onChange?: (geometry: Brecha) => void;
  geometria: GeometryBarragem;
}

export const BrechaConfig: React.FC<Props> = ({ onChange, geometria }) => {
  const [_brecha, setBrecha] = useState<Brecha>(geometria.brecha);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (onChange) onChange(_brecha);
    }, 500);
    return () => clearTimeout(timer);
  }, [_brecha]);

  const onText = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = event.target;

    let newValue: number | string = value;
    if (name !== "idModificou" && name !== "dataCadastro" && name !== "dataModificacao") {
      newValue = parseFloat(value);
    }

    setBrecha(prev => ({
      ...prev,
      [name]: newValue,
    }));
  };

  return <Box sx={{
    width: "100%",
    height: "100%",
    rowGap: "15px",
    columnGap: "15px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  }}>

    <Box sx={{
      flex: 1,
      height: "100%",
      rowGap: "15px",
      display: "flex",
      flexDirection: "column",
    }}>
      <TextField
        fullWidth
        label="Tempo de Formação (min)"
        name="tempo"
        value={_brecha.tempo.toString().replaceAll(".", ",")}
        onChange={(value) => {
          value.target.value = value.target.value.replaceAll(",", ".");
          onText(value);
        }}
        variant="outlined"
      />

      <Box sx={{
        display: "flex",
        flexDirection: "row",
        gap: "15px",
      }}>

        {/* Topo, Fundo, NA Max, Altura */}
        <Box sx={{
          display: "flex",
          flexDirection: "column",
          gap: "15px",
        }}>
          <TextField
            fullWidth
            label="Elevação Topo da Brecha (m)"
            name="elevacaoTopo"
            value={_brecha.elevacaoTopo.toString().replaceAll(".", ",")}
            onChange={(value) => {
              value.target.value = value.target.value.replaceAll(",", ".");
              onText(value);
            }}
            variant="outlined"
          />
          <TextField
            fullWidth
            label="Elevação Fundo da Brecha (m)"
            name="elevacaoFundo"
            value={_brecha.elevacaoFundo.toString().replaceAll(".", ",")}
            onChange={(value) => {
              value.target.value = value.target.value.replaceAll(",", ".");
              onText(value);
            }}
            variant="outlined"
          />
          <TextField
            fullWidth
            label="NA Máximo Atingido (m)"
            name="naMax"
            value={_brecha.naMax.toString().replaceAll(".", ",")}
            onChange={(value) => {
              value.target.value = value.target.value.replaceAll(",", ".");
              onText(value);
            }}
            variant="outlined"
          />
          <TextField
            fullWidth
            label="Altura Brecha (m)"
            name="altBrecha"
            value={_brecha.altBrecha.toString().replaceAll(".", ",")}
            onChange={(value) => {
              value.target.value = value.target.value.replaceAll(",", ".");
              onText(value);
            }}
            variant="outlined"
          />
        </Box>

        {/* Volume, Incli, Lar. Topo, Lar. Base */}
        <Box sx={{
          display: "flex",
          flexDirection: "column",
          gap: "15px",
        }}>
          <TextField
            fullWidth
            label="Volume Escoado (m³)"
            name="volEscoado"
            value={_brecha.volEscoado.toString().replaceAll(".", ",")}
            onChange={(value) => {
              value.target.value = value.target.value.replaceAll(",", ".");
              onText(value);
            }}
            variant="outlined"
          />
          <TextField
            fullWidth
            label="Inclinação Talude da Brecha (m)"
            name="inclTalude"
            value={_brecha.inclTalude.toString().replaceAll(".", ",")}
            onChange={(value) => {
              value.target.value = value.target.value.replaceAll(",", ".");
              onText(value);
            }}
            variant="outlined"
          />
          <TextField
            fullWidth
            label="Lar. Topo Brecha (m)"
            name="larguraTopo"
            value={_brecha.larguraTopo.toString().replaceAll(".", ",")}
            onChange={(value) => {
              value.target.value = value.target.value.replaceAll(",", ".");
              onText(value);
            }}
            variant="outlined"
          />
          <TextField
            fullWidth
            label="Lar. Base Brecha (m)"
            name="larguraBase"
            value={_brecha.larguraBase.toString().replaceAll(".", ",")}
            onChange={(value) => {
              value.target.value = value.target.value.replaceAll(",", ".");
              onText(value);
            }}
            variant="outlined"
          />
        </Box>
      </Box>
    </Box>

    <BrechaSVG
      key={generateRandomHash(8)}
      brecha={_brecha}
      nomeEstrutura={geometria.tipo}
      style={{
        flex: 2,
        height: "300px",
        borderRadius: "15px",
      }}
    />
  </Box>;
};